import { render } from "./customers_import.vue?vue&type=template&id=77c140dc&scoped=true"
import script from "./customers_import.vue?vue&type=script&lang=js"
export * from "./customers_import.vue?vue&type=script&lang=js"

import "./customers_import.vue?vue&type=style&index=0&id=77c140dc&scoped=true&lang=css"

import exportComponent from "/Users/chrisfinlayson/Desktop/WORK/riverhawk-nest/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-77c140dc"]])

export default __exports__